import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id", "multiple"]

import { ref } from 'vue'
import { UiButton } from '@/components/common/ui'
import { IPropsTheButton } from '@/components/common/ui/UiButton.vue'
import { UploadedFileType } from '@/types/partials'

import { useNotifications } from '@/composables/useNotifications'
interface Props {
    id: string
    buttonProps: IPropsTheButton
    multiple?: boolean
    hideSuccess?: boolean
}
interface IEventUiFileUpload {
    (e: 'filesUpload', files: UploadedFileType[]): void
}

export default /*#__PURE__*/_defineComponent({
  props: {
    id: { type: String, required: true },
    buttonProps: { type: null, required: true },
    multiple: { type: Boolean, required: false },
    hideSuccess: { type: Boolean, required: false }
  },
  emits: ["filesUpload"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'filesUpload', files: UploadedFileType[]): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    id: string
    buttonProps: IPropsTheButton
    multiple?: boolean
    hideSuccess?: boolean
}
const { pushSuccess } = useNotifications()

const rawFile = ref(null)





const getBase64 = (file: File) => {
    return new Promise((resolve, reject) => {
        var reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = function() {
            resolve({
                type: file.type,
                base64: reader.result,
                name: file.name,
                id: String(new Date().valueOf() / (Math.random() * 100)),
            })
        }
        reader.onerror = function(error) {
            reject(error)
        }
    })
}

const handleFilesUpload = async () => {
    const promisesArray: Array<Promise<UploadedFileType>> = []

    if (rawFile.value) {
        const files = Object.values(rawFile.value.files)
        files.forEach(element => {
            const file = element as File
            promisesArray.push(getBase64(file))
            rawFile.value.value = ''
        })
        Promise.all(promisesArray).then(values => {
            const files: Array<UploadedFileType> = []
            values.forEach(file => {
                files.push(file)
            })
            emit('filesUpload', files)
            if (!props.hideSuccess) {
                pushSuccess(
                    `Pomyślnie dodano ${files.length <= 1 ? 'plik' : 'pliki: '} ${
                        files.length > 1 ? files.length : ''
                    }`,
                )
            }
        })
    }
}
const onAddFileBtnClick = () => document.getElementById(props.id)?.click()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(UiButton), _mergeProps(props.buttonProps, { onClick: onAddFileBtnClick }), {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default")
      ]),
      _: 3
    }, 16),
    _createElementVNode("input", {
      id: props.id,
      ref: (_value, _refs) => {
        _refs['rawFile'] = _value
        rawFile.value = _value
      },
      class: "hidden",
      type: "file",
      multiple: props.multiple,
      onChange: _cache[0] || (_cache[0] = ($event: any) => (handleFilesUpload()))
    }, null, 40, _hoisted_1)
  ], 64))
}
}

})